import React from 'react'
import { Footer } from '@s4l/uikit'
import { useDispatch } from 'react-redux'

import { clickFooterLink, clickFooterSocial } from 'client/contexts/Tracking/events'
import { sendTrackingRequestAction } from 'client/contexts/Tracking/actions'
import { useMarket } from 'src/hooks/useMarket'

const FooterConnected = () => {
  const dispatch = useDispatch()
  const { faqsUrl } = useMarket()

  function handleTracking(linkId: string) {
    dispatch(sendTrackingRequestAction({ event: clickFooterLink(linkId) }))
  }

  function handleTrackingSocial(linkId: string) {
    dispatch(sendTrackingRequestAction({ event: clickFooterSocial(linkId) }))
  }

  return (
    <Footer faqsUrl={faqsUrl} onLinkClick={handleTracking} onSocialClick={handleTrackingSocial} />
  )
}

export default FooterConnected
